import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressIndicatorComponent } from './components/progress-indicator/progress-indicator.component';
import { PrimengModule } from '../primeng/primeng.module';

@NgModule({
    declarations: [
        ProgressIndicatorComponent
    ],
    imports: [
        CommonModule,
        PrimengModule
    ],
    exports: [
    ]
})
export class SharedModule { }
